import axios from "axios";
import { CONFIG } from "src/global-config";
import store from "src/store"; // Import your Redux store
import {
  selectUserToken,
  selectUserCountryCode,
} from "src/store/selectors/user";
import { clearCart } from "src/store/slices/cart";
import { logout } from "src/store/slices/user";
// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: CONFIG?.apiUrl });
// Add an interceptor to include the token in all requests
axiosInstance.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const token = selectUserToken(state); // Get token from Redux store
    const countryCode = selectUserCountryCode(state); // Get country code from Redux store

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (countryCode) {
      config.headers.countryCode = countryCode?.code;
    }
    config.headers.platform = "customer";
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const state = store.getState();
    const token = selectUserToken(state); // Get token from Redux store
    if (error?.response?.status === 401 && token) {
      store.dispatch(logout());
      store.dispatch(clearCart());
      window.location.href = "/login";
    }

    return Promise.reject(
      (error?.response && error?.response.data) || "Something went wrong!"
    );
  }
);

// ----------------------------------------------------------------------

export default axiosInstance;

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export const endpoints = {
  order: {
    list: "/orders",
    create: "/orders",
    myOrder: "/orders/my-orders",
    applyCoupon: "/coupons",
    shippingRates: "/shipping-rates/rates",
    addons: "optional-services",
    rushOrder: "optional-services/rush-order",
  },
  chat: "/api/chat",
  kanban: "/api/kanban",
  calendar: "/api/calendar",
  auth: {
    me: "/api/auth/me",
    // signIn: '/api/auth/sign-in',
    signIn: "/auth/login",
    signUp: "/auth/register",
    createUser: "/auth/register",
    forgotPassword: "/auth/forgot-password",
    verifyOtp: "/auth/reset-password-otp",
  },
  users: "/users",
  approve: "/users/approve",

  address: "/user-address/my-addresses",
  postAddress: "/user-address",
  deleteAddress: "/user-address",

  mail: {
    list: "/api/mail/list",
    details: "/api/mail/details",
    labels: "/api/mail/labels",
  },
  post: {
    list: "/api/post/list",
    details: "/api/post/details",
    latest: "/api/post/latest",
    search: "/api/post/search",
  },
  product: {
    list: "/products/findall",
    details: "/products/slug",
    search: "/api/product/search",
    id: "/products",
    config: "/products/productConfig",
    calculatePrice: "/products/calculate-price",
  },
  cart: {
    update: "/cart/update/default",
    tax: "/taxes",
    get: "/cart/default",
  },
  category: {
    list: "/category",
  },
  navigation: {
    list: "/products/navigation",
  },
  productTag: {
    products: "/product-tag/products",
  },
  upload: "/file-upload/upload",
  payment: {
    checkout: "/checkout-session",
    nuveiSavedCards: "/checkout-session/nuvei/saved-cards",
    nuveiSavePaymentOption: "/checkout-session/nuvei/save-payment-option",
  },
  pages: {
    page: "/pages",
    blog: "/blogs",
    homePage: "home-page",
  },
  subscriptions: "/subscriptions",
  forms: "/forms",
  creditPoints: "/credits-log/user",
  creditPointsHistory: "/credits-log/history/me",
};
